import StrategyStepsList from '../components/StrategyStepsList';
import CampaignTypeIntegration from '../components/CampaignTypeIntegration';
import PaletteIntegration from '../components/Parameterization/PaletteIntegration';
import PostQuantityIntegration from '../components/PostQuantityIntegration';
import ProductImagesIntegration from '../components/ProductImagesIntegration';
import ApprovalIntegration from '../components/ApprovalIntegration';
import SocialMediaIntegration from '../components/SocialMediaIntegration';
import ScheduleIntegration from '../components/ScheduleIntegration';
import SchedulingProgressIntegration from '../components/SchedulingProgressIntegration';
import StrategyDownloaderIntegration from '../components/StrategyDownloaderIntegration';
import DownloadZipIntegration from '../components/DownloadZipIntegration';
import ArtQueueProgressList from '../components/ArtQueueProgressList';

export const MESSAGE_INTEGRATIONS = {
  strategyProgress: {
    component: StrategyStepsList,
    defaultProps: {},
  },
  artQueueProgress: {
    component: ArtQueueProgressList,
    defaultProps: {},
  },
  campaignType: {
    component: CampaignTypeIntegration,
    defaultProps: {},
  },
  palette: {
    component: PaletteIntegration,
    defaultProps: {},
  },
  postQuantity: {
    component: PostQuantityIntegration,
    defaultProps: {},
  },
  productImages: {
    component: ProductImagesIntegration,
    defaultProps: {},
  },
  strategyApproval: {
    component: ApprovalIntegration,
    defaultProps: {variant: 'strategy'},
  },
  artsApproval: {
    component: ApprovalIntegration,
    defaultProps: {variant: 'arts'},
  },
  completionMode: {
    component: ApprovalIntegration,
    defaultProps: {variant: 'completionMode'},
  },
  batchEditConfirm: {
    component: ApprovalIntegration,
    defaultProps: {variant: 'batchConfirm'},
  },
  batchRejectConfirm: {
    component: ApprovalIntegration,
    defaultProps: {variant: 'batchRejectConfirm'},
  },
  completionActions: {
    component: ApprovalIntegration,
    defaultProps: {variant: 'finalActions'},
  },
  socialMedia: {
    component: SocialMediaIntegration,
    defaultProps: {},
  },
  scheduleConfig: {
    component: ScheduleIntegration,
    defaultProps: {},
  },
  schedulingProgress: {
    component: SchedulingProgressIntegration,
    defaultProps: {},
  },
  strategyDownloader: {
    component: StrategyDownloaderIntegration,
    defaultProps: {},
  },
  downloadZip: {
    component: DownloadZipIntegration,
    defaultProps: {},
  },
};
